module.exports = __webpack_public_path__ + "static/og-95fa1fc278238f4c009da2abb33b66df.png";